const paper_project = {
  title: 'Academic Papers',
  description: 'A collection of academic papers I\'ve written across psychology, computer science, philosophy, cognitive science, and linguistics.',

  sections: [],
  docLink: [
    {
      title: "An Investigation of Uncanny Architecture using Artificial Text-to-Image Generation",
      course: "ARTH 47.04: Architecture and The Uncanny",
      date: "November 23, 2022",
      target: 'https://drive.google.com/uc?id=1SnpRQ_-zgZRcfhGKy21RZ4m1bLPyY9DN',
    },
    {
      title: "Mommy on my Mind: How Thinking about Family Impacts Risk-Taking Tendencies",
      course: "PSYC 011: Experiment Design in Psychology",
      date: "June 2, 2022",
      target: 'https://drive.google.com/uc?id=18SluAa8afR-OfM3aNEhy31VxigFLmic7',
    },
    {
      title: "Party Planning: How Political Psychology Informs the Ideal Party System for America",
      course: "GOVT 039: Political Psychology",
      date: "February 16, 2022",
      target: 'https://drive.google.com/uc?id=1hLXIEB-En4elUyemttzf5UdajRsQmJFg',
    },
    {
      title: "From DM\'s to A\'s: Academic Performance Varies with Online Social Network Structure",
      course: "COGS 080: Major in Cognitive Science Seminar",
      date: "November 28, 2021",
      target: 'https://drive.google.com/uc?id=1HXGZxG9WrXciRhGo46E7wgTbX5dOoT8e',
    },
    {
      title: "Ethics of AI: Biases in the World We Inhabit and the Technology We Create",
      course: "COSC 076: Artificial Intelligence",
      date: "November 26, 2021",
      target: 'https://drive.google.com/uc?id=1clxe7dMJGcADHYUqPMKbcKUBGiwvS6Hb',
    },
    {
      title: "Toward Artificial Theory of Mind: Can Your AI-Assistant Understand Your World View?",
      course: "COGS 001: Introduction to Cognitive Science",
      date: "June 7, 2020",
      target: 'https://drive.google.com/uc?id=1d05Edhby7y7-qF7za153oiL1_g1XdBZT',
    },
    {
      title: "Similarities Between Language and Music May Inform Text-Generating AI",
      course: "COGS 001: Introduction to Cognitive Science",
      date: "May 7, 2020",
      target: 'https://drive.google.com/uc?id=1dopaDdH2yBG2zO892U_FbUJJ-_IiHg0v',
    },
    {
      title: "Self-Driving Black Box: The Dangers of Automated Decision-Making on the Road",
      course: "GEOG 008: Charting Self-Driving Cars",
      date: "January 18, 2020",
      target: 'https://drive.google.com/uc?id=1Q7k0-3r197JlaDR-5BI0Zhmbwo79mkQD',
    },
  ],
};

export default paper_project;